import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { map } from 'rxjs/operators';
import { SeoService } from 'src/app/Shared/_services/seo/seo.service';
import { LandingService } from '../_services/landing.service';

export const blogSeoResolver: ResolveFn<boolean> = (route) => {
  const seoService = inject(SeoService);
  const landingService = inject(LandingService);
  const slug = route.paramMap.get('slug') || '';

  return landingService.getBlogDetails(slug).pipe(
    map((blog) => {
      seoService.setSeo(
        blog.title || 'Blog Article',
        blog.meta_description || 'Read our latest blog articles',
        blog.featured_image || ''
      );
      return true;
    })
  );
};
